import {ErrorHandler, Injectable, NgZone,} from '@angular/core';
import {Logger,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        LoginInfoService,
        StringUtil,
        WindowService,} from '@services/index';
import {LoginUserVO, MessageLevel,} from '@models/index';
import {SMS011ErrorInVO,} from '@pages/sms011-error/sms011-error-in-vo';

@Injectable({
  providedIn: 'root',
})
export class ThrownErrorHandler implements ErrorHandler {

  previousDate = new Date();
  counterForCheckRecursive = 0;
  stopped = false;

  constructor(
    private ngZone: NgZone,
    private screenMessage: ScreenMessageHandler,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    public stringUtil: StringUtil,
    private loginInfoService: LoginInfoService,
    private logger: Logger
  ) {
  }

  /**
   * [一般開発者利用不可]
   * エラーがthrowされた時のハンドリング。Angularが自動的にコールする。
   * @param error
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  handleError(error: any): any {
    if (this.checkIfErrorRecursive()) {
      return;
    }
    this.ngZone.run(() => {
      // MessageStackがthrowされた場合は、ログに出力してMessageStackの内容を画面に表示する
      if (error instanceof MessageStackService) {
        // クライアントログの出力
        switch (error.messageLevel) {
          case MessageLevel.ERROR:
            error.messages.forEach(message =>
              this.logger.error(message.messageId, message.messageParams)
            );
            break;
          case MessageLevel.WARN:
            error.messages.forEach(message =>
              this.logger.warn(message.messageId, message.messageParams)
            );
            break;
          case MessageLevel.INFO:
            error.messages.forEach(message =>
              this.logger.info(message.messageId, message.messageParams)
            );
            break;
        }
        // 画面へのメッセージ出力
        this.screenMessage.showMessage(error);

      } else {
        // その他のエラーの場合(主に予期していないエラー)

        // クライアントログの出力
        this.logger.errorWithFreeText(error);

        // エラー画面へ遷移
        const messageStack = new MessageStackService(MessageLevel.ERROR);
        messageStack.add({messageId: 'SMS99901M013E',});

        // POSTパラメータ設定
        const info011Vo: SMS011ErrorInVO = new SMS011ErrorInVO();
        info011Vo.messageStack = messageStack;

        const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
        if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
          && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
          && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

          // ログイン情報が取得出来た場合、必要な値をセット
          info011Vo.hashId = connVo.hashId;
          info011Vo.menuNo = connVo.menuNo;
          info011Vo.languageType = connVo.languageType;
        } else {
          // ログイン情報が取得出来なかった場合、固定値をセット
          info011Vo.hashId = '';
          info011Vo.menuNo = '';
          info011Vo.languageType = '01';
        }
        this.windowService.transit<SMS011ErrorInVO>('SMS011', info011Vo);

        // ★Memo
        // ICSではシステム的なthrowは、Snackbarに表示していたがSMSではエラー画面に遷移させる
        // this.screenMessage.showMessage(messageStack);
      }
    });
  }

  /**
   * [一般開発者利用不可]
   * 短時間に連続してエラーが発生していないかどうかのチェック
   * @private
   */
  private checkIfErrorRecursive(): boolean {
    if (this.stopped) {
      return true;
    }
    const currentDate = new Date();
    if (currentDate.getTime() - this.previousDate.getTime() <= 500) {
      this.counterForCheckRecursive += 1;
      if (this.counterForCheckRecursive >= 5) {
        this.logger.warn('CSS01999M028W');
        this.stopped = true;
        return true;
      } else {
        return false;
      }
    }
    this.counterForCheckRecursive = 0;
    this.previousDate = currentDate;
    return false;
  }
}
